module.exports = __webpack_public_path__ + "9bff34c415bea7c61c47f160e0fe5cfe.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-98@2x.png
// module id = 548
// module chunks = 0